import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
const LazyLoadedElevioResolutionModal = lazy(() => import('./elevioResolutionModal'));
export function ElevioResolutionModalWrapper() {
    const { elevioSuggestions } = useFeatureFlag(['elevio-suggestions']);
    return (_jsx(Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: elevioSuggestions && _jsx(LazyLoadedElevioResolutionModal, {}) })));
}
